var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0695 30.9958C24.2978 30.9958 30.9681 24.3255 30.9681 16.0972C30.9681 7.86893 24.2978 1.19861 16.0695 1.19861C7.84122 1.19861 1.1709 7.86893 1.1709 16.0972C1.1709 24.3255 7.84122 30.9958 16.0695 30.9958Z",
    stroke: "#F36F2E",
    strokeWidth: 1.1036
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2469 8C10.386 8 9.56032 8.34191 8.95144 8.95056C8.34256 9.5592 8.00033 10.3847 8 11.2457V19.9041C8 20.7652 8.34208 21.5911 8.951 22.2C9.55991 22.8089 10.3858 23.151 11.2469 23.151H19.9053C20.7663 23.1507 21.5918 22.8084 22.2004 22.1996C22.8091 21.5907 23.151 20.765 23.151 19.9041V11.2457C23.1507 10.385 22.8086 9.55961 22.2 8.951C21.5914 8.34239 20.766 8.00033 19.9053 8H11.2469ZM20.8393 11.2507C20.8393 11.4987 20.7407 11.7365 20.5654 11.9119C20.39 12.0873 20.1521 12.1858 19.9041 12.1858C19.6561 12.1858 19.4182 12.0873 19.2428 11.9119C19.0674 11.7365 18.9689 11.4987 18.9689 11.2507C18.9689 11.0026 19.0674 10.7648 19.2428 10.5894C19.4182 10.414 19.6561 10.3155 19.9041 10.3155C20.1521 10.3155 20.39 10.414 20.5654 10.5894C20.7407 10.7648 20.8393 11.0026 20.8393 11.2507ZM15.5774 12.9813C14.8895 12.9813 14.2298 13.2546 13.7435 13.741C13.2571 14.2274 12.9838 14.887 12.9838 15.5749C12.9838 16.2627 13.2571 16.9224 13.7435 17.4088C14.2298 17.8952 14.8895 18.1684 15.5774 18.1684C16.2652 18.1684 16.9249 17.8952 17.4113 17.4088C17.8977 16.9224 18.1709 16.2627 18.1709 15.5749C18.1709 14.887 17.8977 14.2274 17.4113 13.741C16.9249 13.2546 16.2652 12.9813 15.5774 12.9813ZM11.7357 15.5749C11.7357 14.5563 12.1403 13.5795 12.8605 12.8593C13.5807 12.1391 14.5576 11.7344 15.5761 11.7344C16.5947 11.7344 17.5715 12.1391 18.2917 12.8593C19.0119 13.5795 19.4166 14.5563 19.4166 15.5749C19.4166 16.5934 19.0119 17.5703 18.2917 18.2905C17.5715 19.0107 16.5947 19.4153 15.5761 19.4153C14.5576 19.4153 13.5807 19.0107 12.8605 18.2905C12.1403 17.5703 11.7357 16.5934 11.7357 15.5749Z",
    fill: "#F36F2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_1680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4666b7cdb4bed1377c78ea133c8dada2.svg";
export { ForwardRef as ReactComponent };